import React, { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { useQueryClient } from '@tanstack/react-query';
import { useTopPairInventory } from 'api/dashboardApi';
import {
  DiamondBoardIcon,
  FoodBoardIcon,
  GoldBoardIcon,
  TabBg,
  WoodBoardIcon,
} from 'assets/images';
import LanguageDropdown from 'components/UI/LanguageDropdown';
import { SOCKET_EVENTS } from 'socket/constants';
import useSocketEvent from 'socket/hooks/useSocketEvent';

import PriceBoard from '../PriceBoard';

import './style.scss';
import { formatAmount } from './helper';

const ID_TO_NAME = {
  1: 'diamond',
  2: 'gold',
  3: 'wood',
  4: 'food',
};

const Topbar = ({ pageName }) => {
  const { t } = useTranslation();
  const resolvedPageName = pageName ?? t('topBar.defaultPageName');
  const queryClient = useQueryClient();
  const { data: { data: { data: topList = [] } = {} } = {} } = useTopPairInventory();
  const [inventory, setInventory] = useState([]);

  useEffect(() => {
    if (topList.length) setInventory(topList);
  }, [topList]);

  useSocketEvent({ subscribe: SOCKET_EVENTS.PAIR_INVENTORY_UPDATE }, null, {
    onlyListen: true,
    onMessage: (updated) => {
      setInventory((prev) => {
        const exists = prev.some((item) => item.pairId === updated.pairId);
        if (exists) {
          return prev.map((item) => (item.pairId === updated.pairId ? { ...item, ...updated } : item));
        } else {
          return [...prev, updated];
        }
      });
      queryClient.invalidateQueries({ queryKey: ['top-pair'] });
    },
  });

  const selectedTop = (id) =>
    inventory.find((item) => item.pairId === id) ||
    inventory.find((item) => item.fullName?.toLowerCase() === ID_TO_NAME[id]);
  const diamond = selectedTop(1);
  const gold = selectedTop(2);
  const wood = selectedTop(3);
  const food = selectedTop(4);
  return (
    <div className="Topbar">
      <div className="topbar-language-dropdown">
        <LanguageDropdown />
      </div>
      <div className="top-item">
        <PriceBoard
          img={DiamondBoardIcon}
          title={formatAmount(diamond?.quantity)}
        />
      </div>
      <div className="top-item">
        <PriceBoard
          img={GoldBoardIcon}
          title={formatAmount(gold?.quantity)}
        />
      </div>

      <div className="top-center">
        <img alt="center logo" src={TabBg} />
        <span className="title">{resolvedPageName}</span>
      </div>

      <div className="top-item">
        <PriceBoard
          img={WoodBoardIcon}
          title={formatAmount(wood?.quantity)}
        />
      </div>
      <div className="top-item">
        <PriceBoard
          img={FoodBoardIcon}
          title={formatAmount(food?.quantity)}
        />
      </div>
    </div>
  );
};

export default Topbar;
